import React, { FC } from 'react'

import { alpha, Box, useTheme } from '@mui/material'
import { every } from 'lodash'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { chartOptions } from '../chartOptions'
import { EmptyData } from '../EmptyData'
import { ReportWidgetsHeader } from '../ReportWidgetsHeader'
import { StyledWidgetWrapper } from '../StyledWidgetWrapper'
import { TradeDistributionType } from '../types'

export const TradeDistributionWidget: FC<{
  data: TradeDistributionType[] | undefined
  displayWidth: number
}> = ({ data, displayWidth }) => {
  const { t } = useTranslation()
  const { spacing, palette } = useTheme()

  const chartData = {
    labels: data?.map((item) => item.time),
    datasets: [
      {
        label: t('trades', 'Trades'),
        data: data?.map((item) => item.amount),
        backgroundColor: palette.blue[500],
        barThickness: 25,
        borderRadius: 2,
        hoverBackgroundColor: alpha(palette.blue[500] as string, 0.8),
      },
    ],
  }

  return (
    <StyledWidgetWrapper>
      <ReportWidgetsHeader
        text={t('tradeDistribution', 'Trade distribution')}
        explanation={t(
          'theGraphRepresentsWhatAreTheMostPopularPeriodsForTrading',
          'The graph represents what are the most popular periods for trading',
        )}
      />

      {every(data, { amount: 0 }) ? (
        <Box mt={4}>
          <EmptyData />
        </Box>
      ) : (
        <Box ml={spacing(-3)}>
          <Bar
            data={chartData}
            options={chartOptions()}
            style={{ maxHeight: spacing(31) }}
            key={displayWidth}
          />
        </Box>
      )}
    </StyledWidgetWrapper>
  )
}
